module.exports = __webpack_public_path__ + "img/img_xb@2x.36c14ec5.png";